import { handleSettledPromises } from '@kk/shared/utils/async';
import { assertParamsPrescence } from '@kk/shared/utils/validators';
import { useRouteLoaderData } from 'react-router';
import api from '#/api';
import { assertNoLoaderErrors } from '#/api/errors';
import { fetchAllDocumentsQuery } from '#/api/hooks/useAllDocuments';
import { fetchCompanyInfoQuery } from '#/api/hooks/useCompanyInfo';
import { fetchLoanDebtInfo } from '#/api/hooks/useLoanDebtInfo';
import type { InferLoaderData } from '#/routes/types';

export type LoaderData = InferLoaderData<typeof loader>;

export type Params = Record<string, string | undefined>;

export const id = 'frontPage' as const;

async function loader({ params }: { params: Params }) {
  assertParamsPrescence(params);
  const data = await handleSettledPromises([
    fetchLoanDebtInfo(),
    fetchCompanyInfoQuery(),
    fetchAllDocumentsQuery({ filter: api.DocumentStatusFilter.Active }),
  ]);

  assertNoLoaderErrors(id, data);

  const [loanDebtInfo, companyInfo, documentsData] = data;
  return { loanDebtInfo, companyInfo, documentsData };
}

export const useFrontPageLoaderData = () =>
  useRouteLoaderData(id) as LoaderData;

export default loader;
